import { io } from 'socket.io-client'

const RECONNECTION_DELAY = 1000
const RECONNECTION_DELAY_MAX = 5000
const RECONNECTION_ATTEMPTS = 5

var socketInstance

export const SocketEvent = {
  ADMIN_SEND: 'admin send',
  ADMIN_MESSAGE: 'admin message',
  ADMIN_READ: 'admin read',
  ADMIN_TRANSLATE: 'admin translate',
  ADMIN_ALLOW_TRANSLATION: 'admin allow translation',
  USER_SEND: 'user send',
  USER_READ: 'user read',
  USER_MESSAGE: 'user message',
  ADMIN_COUNTER: 'admin counter',
  UPDATE_TEAM_MEMBER: 'update admin',
  UPDATE_ROLE: 'update role',
  UPDATE_GROUP: 'update group',
  UPDATE_TAG: 'update tag',
  UPDATE_PLACE: 'update place',
}

export const makeConnection = (url, accessToken) => {
  if (socketInstance) {
    return socketInstance
  }
  socketInstance = io.connect(url, {
    query: `token=${accessToken}`,
    reconnection: true,
    reconnectionDelay: RECONNECTION_DELAY,
    reconnectionDelayMax: RECONNECTION_DELAY_MAX,
    reconnectionAttempts: RECONNECTION_ATTEMPTS,
    transports: ['websocket', 'polling'],
    autoConnect: true,
  })
  return socketInstance
}

export const teardownSocketConnection = () => {
  if (!socketInstance) {
    return
  }
  socketInstance.off(SocketEvent.ADMIN_MESSAGE)
  socketInstance.off('connect')
  socketInstance.off('disconnect')
  socketInstance.off(SocketEvent.ADMIN_ALLOW_TRANSLATION)
  socketInstance.off(SocketEvent.ADMIN_TRANSLATE)
  socketInstance.off(SocketEvent.ADMIN_READ)
  socketInstance.off(SocketEvent.UPDATE_TEAM_MEMBER)
  socketInstance.off(SocketEvent.UPDATE_ROLE)
  socketInstance.off(SocketEvent.UPDATE_GROUP)
  socketInstance.off(SocketEvent.UPDATE_TAG)
  socketInstance.off(SocketEvent.UPDATE_PLACE)
  socketInstance.off(SocketEvent.ADMIN_COUNTER)
  socketInstance.disconnect()
  socketInstance = null
}
